import React, { useEffect, useState } from 'react';
import {
  StyleSheet,
} from 'react-native';

import WhatsAppIcon from '../../../assets/Icons/Whatsapp';
import gs from '../../styles/globalStyles';
import BottomSheetContainer from '../Bottomsheet/Bottomsheet';
import { ThemedText } from '../../theme';
import {ThemedTouchableOpacity}  from '../../theme/Components';
import { useAppSelector } from '../../store/hooks';
import { checkColor, useDarkMode } from '@app/utils';
import ContactUs from '@app/screens/UserProfile/ContactUs';




const NeedHelp = ({callDataVisible=false,triggerOpen=false,setTriggerOpen=null}) => {
  const { emailData,waData,showCall,callData ,platform, isfromTDL} = useAppSelector((state) => state.platformParams);
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const isDarkMode = useDarkMode()

  const closeBottomSheet = () => {
    setIsBottomSheetVisible(false);
    if(setTriggerOpen!==null){
      setTriggerOpen(false)
    }
  };

  useEffect(()=>{
    if(triggerOpen){
      setIsBottomSheetVisible(true)
    }

  },[triggerOpen])

  if(isfromTDL){
    return null
  }

  return (
    <>
      <ThemedTouchableOpacity
        eventName='NEED_HELP_HEADER'
        onPress={() => setIsBottomSheetVisible(true)}
        disabled={isfromTDL}
        bg={'bg-fill-emphasis-primary-1'}
        flexDirection={'row'}
        borderRadius={'2xl'}
        alignItems={'center'}
        paddingHorizontal={'sm'}
        paddingVertical={'xs'}>
        <WhatsAppIcon />
        <ThemedText variant='b5r' color='text-action-primary' >
          NEED HELP?
        </ThemedText>
      </ThemedTouchableOpacity>
      <BottomSheetContainer
        showCloseIcon
        isVisible={isBottomSheetVisible}
        close={closeBottomSheet}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={gs.setBg('#fefefe')}>
        <ContactUs />
      </BottomSheetContainer>
    </>
  );
};

const ls = StyleSheet.create({
  container: {
    borderColor: '#d0d6f5',
    backgroundColor: '#fafbfe',
    borderRadius: 12,
    borderWidth: 1,
    marginTop: 16,
    padding: 16,
  },
});

export default NeedHelp;
